import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";

function CTA() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt mb-[80px] xl:mb-[160px] relative z-50">
      <div className="glcontainer">
        <div className="flex flex-col items-center gap-[40px] text-center max-w-[808px] mx-auto">
          <div className="flex flex-col gap-[20px] items-center">
            <h2 className="font-48-28">{t("home.cta.title")}</h2>
            <p className="font-18-14 max-w-[643px]">{t("home.cta.desc")}</p>
          </div>
          <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
        </div>
      </div>
    </section>
  );
}

export default CTA;
